import { render, staticRenderFns } from "./location-create.vue?vue&type=template&id=2576a78b"
import script from "./location-create.vue?vue&type=script&lang=js"
export * from "./location-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports